import { APIFormType, CompletedFormType, CompletedFormsType, FormType } from '@/types/form'
import { createQuery } from '../api/query'

export const keyForms = (arg: string) => [`/forms`, arg]
export const useQueryForms = createQuery<APIFormType>({
    key: keyForms,
    url: '/forms',
})

export const keyForm = (arg: string) => [`/form`, arg]
export const useQueryForm = createQuery<FormType>({
    key: keyForm,
    url: '/form',
})

export const keyCompletedForms = (arg: string) => [`/completed-forms`, arg]
export const useQueryCompletedForms = createQuery<CompletedFormsType>({
    key: keyCompletedForms,
    url: '/completed-forms',
})

const keyCompletedForm = (arg: string) => [`/completed-form`, arg]
export const useQueryCompletedForm = createQuery<CompletedFormType>({
    key: keyCompletedForm,
    url: '/completed-form',
})
